/**
 * @generated SignedSource<<918eb2e46f1b07526fcf7e7bba62fdef>>
 * @relayHash 7cebb6100267d8ac81b652ebb261dbf2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID adf3712d019249638034f594a86b0c15f44172d208ecd84609fe0197d0949a64

import type { ConcreteRequest } from 'relay-runtime';
export type useTrashedSpaceHardDeleteSpaceMutation$variables = {
  spaceKey: string;
};
export type useTrashedSpaceHardDeleteSpaceMutation$data = {
  readonly hardDeleteSpace: {
    readonly success: boolean;
    readonly taskId: string | null | undefined;
  } | null | undefined;
};
export type useTrashedSpaceHardDeleteSpaceMutation = {
  response: useTrashedSpaceHardDeleteSpaceMutation$data;
  variables: useTrashedSpaceHardDeleteSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "HardDeleteSpacePayload",
    "kind": "LinkedField",
    "name": "hardDeleteSpace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "taskId"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useTrashedSpaceHardDeleteSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTrashedSpaceHardDeleteSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7cebb6100267d8ac81b652ebb261dbf2",
    "id": "adf3712d019249638034f594a86b0c15f44172d208ecd84609fe0197d0949a64",
    "metadata": {},
    "name": "useTrashedSpaceHardDeleteSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation useTrashedSpaceHardDeleteSpaceMutation($spaceKey:String!){hardDeleteSpace(spaceKey:$spaceKey){taskId,success}}"
  }
};
})();

(node as any).hash = "795f694b982fb4bd1390300de6001133";

export default node;
